import { render } from "./edit.vue?vue&type=template&id=4b0f2283&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=4b0f2283&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0f2283"]])

export default __exports__